/* Empty cart — "This week at the studio", as a custom element.
   The drawer re-renders its HTML client-side when the cart changes, and
   scripts inside injected HTML never execute — which is why the inline
   version showed skeletons forever after you emptied the cart. A custom
   element's connectedCallback runs EVERY time the markup enters the DOM,
   however it got there, so this file registers <cart-empty-sessions>
   once (it loads with the drawer on first paint) and each render boots
   itself. */
(function () {
  'use strict';
  if (window.customElements.get('cart-empty-sessions')) return;

  var ENGINE = 'https://book.kraftstories.com';
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DOW = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(c) { return '$' + (c / 100).toFixed(c % 100 ? 2 : 0); }
  function iso(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  /* Location memory: the same localStorage key the loctab experiment's
     recorder writes (ks_ab_lastloc), so the two systems share one notion
     of "the city this visitor browses". A page with a city in its URL
     refreshes the memory; a neutral page (like /cart) reads it. */
  var LOC_KEY = 'ks_ab_lastloc';
  var TOKEN_TO_CITY = {
    'fidi': 'New York', 'new york': 'New York', 'honolulu': 'Honolulu',
    'san francisco': 'San Francisco', 'san jose': 'San Jose',
    'los angeles': 'Los Angeles', 'irvine': 'Irvine', 'austin': 'Austin',
    'virtual': 'Virtual'
  };
  var CITY_TO_TOKEN = {
    'New York': 'new york', 'Honolulu': 'honolulu',
    'San Francisco': 'san francisco', 'San Jose': 'san jose',
    'Los Angeles': 'los angeles', 'Irvine': 'irvine', 'Austin': 'austin'
  };

  function detectCity() {
    var pth = (location.pathname || '').toLowerCase();
    var MAP = [
      [/\/(new-york|nyc|financial-district)/, 'New York'],
      [/\/(honolulu|hawaii)/, 'Honolulu'],
      [/\/(san-francisco|sf-soma|sf-fidi|bay-area)/, 'San Francisco'],
      [/\/san-jose/, 'San Jose'],
      [/\/los-angeles/, 'Los Angeles'],
      [/\/irvine/, 'Irvine'],
      [/\/(austin|texas-austin)/, 'Austin']
    ];
    for (var i = 0; i < MAP.length; i++) {
      if (MAP[i][0].test(pth)) {
        var c = MAP[i][1];
        try { if (CITY_TO_TOKEN[c]) window.localStorage.setItem(LOC_KEY, CITY_TO_TOKEN[c]); } catch (e) {}
        return c;
      }
    }
    // Neutral page: fall back to the city this visitor last browsed.
    try {
      var tok = (window.localStorage.getItem(LOC_KEY) || '').toLowerCase();
      if (tok && TOKEN_TO_CITY[tok]) return TOKEN_TO_CITY[tok];
    } catch (e) {}
    return '';
  }

  /* One shared fetch per page: several drawer re-renders reuse it. */
  var feed = null;
  function getFeed() {
    if (!feed) {
      feed = window.fetch(ENGINE + '/api/search/experiences?q=').then(function (r) { return r.json(); })
        .then(function (d) { return (window.ksPublished ? window.ksPublished() : Promise.resolve(null)).then(function (set) { if (window.ksKeepPublished) window.ksKeepPublished(d, set); return d; }); });
    }
    return feed;
  }

  function proto() {
    var el = Object.create(HTMLElement.prototype);

    el.connectedCallback = function () {
      var root = this;
      if (root.dataset.cesReady) return;
      root.dataset.cesReady = '1';

      var city = detectCity();
      var listEl = root.querySelector('[data-ces-sessions]');
      var headingEl = root.querySelector('[data-ces-heading]');
      var calEl = root.querySelector('[data-ces-calendar]');
      if (city) {
        if (headingEl) headingEl.textContent = 'This week in ' + city + '.';
        if (calEl) calEl.textContent = 'Full calendar · ' + city;
      }

      getFeed()
        .then(function (d) { root.renderSessions(d, city, listEl); })
        .catch(function () {
          if (listEl) listEl.innerHTML = '<p class="ces-empty">Could not load this week’s sessions. Browse the kits below, or refresh.</p>';
        });

      root.wireGiftCard();
    };

    el.renderSessions = function (d, city, listEl) {
      if (!listEl) return;
      var today = new Date();
      var weekEnd = new Date(today.getTime() + 7 * 864e5);
      var todayIso = iso(today), weekEndIso = iso(weekEnd), tomorrowIso = iso(new Date(today.getTime() + 864e5));

      var cards = (d.cards || []).filter(function (c) { return c.next; });
      if (city) {
        var local = cards.filter(function (c) { return c.city === city; });
        if (local.length) cards = local;
      }
      // Most-booked first (pop is the engine's booking count — the
      // workshop finder sorts by the same field); soonest breaks ties.
      cards.sort(function (a, b) {
        var dp = (b.pop || 0) - (a.pop || 0);
        if (dp) return dp;
        return a.next.d < b.next.d ? -1 : a.next.d > b.next.d ? 1 : 0;
      });

      // One row per class, four max — and when the list spans cities,
      // "Air-Dry Clay Workshop in San Francisco" and "... in San Jose"
      // are the same class twice, so dedupe on the title's root too.
      var seen = {}, rows = [];
      for (var i = 0; i < cards.length && rows.length < 4; i++) {
        var rootKey = String(cards[i].title || cards[i].handle).toLowerCase().split(' in ')[0];
        if (seen[cards[i].handle] || seen[rootKey]) continue;
        seen[cards[i].handle] = 1; seen[rootKey] = 1;
        rows.push(cards[i]);
      }
      if (!rows.length) {
        listEl.innerHTML = '<p class="ces-empty">No sessions on the calendar just now — take a look at the kits below.</p>';
        return;
      }

      listEl.innerHTML = rows.map(function (c) {
        var parts = String(c.next.label || '').split(' · ');
        var when = parts[1] || parts[0] || '';
        var dt = new Date(c.next.d + 'T12:00:00');
        var dayWord = c.next.d === todayIso ? 'Today' : c.next.d === tomorrowIso ? 'Tomorrow' : DOW[dt.getDay()];
        var seats = c.next.open;
        var seatTxt = seats <= 3
          ? '<span class="low">' + seats + ' seat' + (seats === 1 ? '' : 's') + ' left</span>'
          : seats + ' seats';

        // This week's other days for the same class, as small chips.
        var week = (c.days || []).filter(function (dd) {
          return dd.d > c.next.d && dd.d <= weekEndIso && dd.open > 0;
        }).slice(0, 4);
        var chips = week.length
          ? '<span class="ces-days">' + week.map(function (dd) {
              var wdt = new Date(dd.d + 'T12:00:00');
              return '<span class="ces-day">' + DOW[wdt.getDay()] + ' ' + wdt.getDate() + '</span>';
            }).join('') + '</span>'
          : '';

        // The engine's listing_url is the metaobject page
        // (/pages/<location>/<workshop-name>) — the page a visitor
        // should land on, not the bare product. Relative, so the link
        // stays on whatever domain served this page.
        var href = String(c.listing_url || '/products/' + c.handle).replace(/^https?:\/\/[^/]+/, '') || ('/products/' + c.handle);
        if (/\/undefined($|\?)/.test(href)) href = c.handle ? '/products/' + c.handle : '/pages/find-a-workshop';
        return '<a class="ces-sess" href="' + esc(href) + '">' +
            '<span class="ces-date"><span>' + esc(dayWord) + '</span><b>' + dt.getDate() + '</b><small>' + MON[dt.getMonth()] + '</small></span>' +
            '<span><span class="ces-t">' + esc(c.title) + '</span>' +
              '<span class="ces-s">' + esc(when) + ' · ' + esc(c.venue_name) + ' · ' + seatTxt + '</span>' + chips + '</span>' +
            '<span class="ces-book">Book · ' + money(c.price_cents) + '</span>' +
          '</a>';
      }).join('');
    };

    el.wireGiftCard = function () {
      var root = this;
      var amts = [].slice.call(root.querySelectorAll('[data-ces-gc]'));
      var addBtn = root.querySelector('[data-ces-gc-add]');
      var errEl = root.querySelector('[data-ces-gc-err]');
      var chosen = amts[0] || null;

      function paint() {
        amts.forEach(function (b) { b.classList.toggle('on', b === chosen); });
        if (addBtn) addBtn.textContent = chosen ? 'Add ' + chosen.dataset.price + ' gift card' : 'Add gift card';
      }
      amts.forEach(function (b) {
        b.addEventListener('click', function () { chosen = b; if (errEl) errEl.hidden = true; paint(); });
      });
      paint();

      if (!addBtn) return;
      addBtn.addEventListener('click', function () {
        if (!chosen) return;
        addBtn.disabled = true;
        var label = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        window.fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(chosen.dataset.cesGc), quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add the gift card.'); });
            window.location.reload();
          })
          .catch(function (e) {
            addBtn.disabled = false; addBtn.textContent = label;
            if (errEl) { errEl.textContent = e.message; errEl.hidden = false; }
          });
      });
    };

    return el;
  }

  function Ctor() { return Reflect.construct(HTMLElement, [], Ctor); }
  Ctor.prototype = proto();
  Object.setPrototypeOf(Ctor, HTMLElement);
  window.customElements.define('cart-empty-sessions', Ctor);
})();
